import { Button, cn } from "@heroui/react";
import { IconMenu2, IconX } from "@tabler/icons-react";
import { useSidebar } from "../../hooks";

export const SidebarButton = ({
  additionalClassNames,
}: {
  additionalClassNames?: string;
}) => {
  const { isOpen, setIsOpen } = useSidebar();
  return (
    <Button
      variant={"light"}
      data-drawer-target="default-sidebar"
      data-drawer-toggle="default-sidebar"
      aria-controls="default-sidebar"
      type="button"
      isIconOnly={true}
      className={cn("p-2 text-sm rounded-lg z-40", additionalClassNames)}
      onPress={() => setIsOpen(!isOpen)}
    >
      <span className="sr-only">Open sidebar</span>
      {isOpen ? <IconX /> : <IconMenu2 />}
    </Button>
  );
};
